module.exports = __webpack_public_path__ + "img/lv5.4fd5f6e5.png";